require("./ynet_ynetnews_vesty_site_verticalVideoOverlayPlayer.less");
import { VerticalVideoItem } from "./designs/verticalVideoItem/VerticalVideoItem";
import { VerticalVideoGallery } from "./verticalVideoGallery";
import { SiteItemData } from "../../interfaces";
import { useEffect, useState } from "react";
import { categoryObj } from "../ynet1280/newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { useVerticalItemSizing } from "./hooks/useVerticalItemSizing";
import { MediaContentTypes } from "../../../constants/contentTypes";

interface VerticalVideoOverlayPlayerProps {
    domain: string;
    isLTR: boolean;
    category: categoryObj
    isMobile: boolean;
    videoItems: SiteItemData | SiteItemData[];
    languageCode: string;
    isOverlayOpen: boolean;
    showPrerollAds: boolean;
    isTitleVisible: boolean;
    isSubTitleVisible: boolean;
    index?: number; //used in gallery view
    overlayTitle?: string;
    headerClassName?: string;
    selectedVideoIndex?: number; //used in gallery view
    headerLogoClassName?: string;
    isSingleVideoDisplay?: boolean;
    onVideoOverlayClose: () => void;
    ItemComponent?: (props: any) => any;
}

export const VerticalVideoOverlayPlayer = (props: VerticalVideoOverlayPlayerProps) => {
    const { isOverlayOpen, index, isSingleVideoDisplay, onVideoOverlayClose, domain, videoItems, languageCode, showPrerollAds, isTitleVisible, selectedVideoIndex, isSubTitleVisible, isLTR, isMobile, headerClassName, ItemComponent, overlayTitle, headerLogoClassName } = props;
    const Item = ItemComponent || VerticalVideoItem; //keeping verticalVideoItem the default choice
    const [currentPlayingVideo, setCurrentPlayingVideo] = useState<number>(selectedVideoIndex);

    // Calculate sizing once for single-video display
    const { containerStyle, dynamicHeight, dynamicWidth } = useVerticalItemSizing({ isMobile, headerClassName });

    useEffect(() => {
        setCurrentPlayingVideo(selectedVideoIndex);
    }, [selectedVideoIndex])

    useEffect(() => {
        if (isOverlayOpen && !isMobile) {
            positionCloseButtonUnderHeader();
        }
    }, [isOverlayOpen])

    useEffect(() => {
        document.addEventListener('keydown', handleEscKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscKeyPress);
        }
    })

    const handleEscKeyPress = (e) => {
        if (e.keyCode === 27) {
            onVideoOverlayClose();
        }
    }

    const positionCloseButtonUnderHeader = () => {
        const headerClassName = props.headerClassName ? props.headerClassName : ".BottomHeaderArea.sticky .mainNav";
        const closeButton = document.querySelector(".vertical-video-overlay-player .close-btn") as HTMLElement;
        const mainNavElement = document.querySelector(headerClassName) as HTMLElement;

        if (closeButton && mainNavElement) {
            const headerRect = mainNavElement.getBoundingClientRect();
            closeButton.style.right = `${headerRect.left + 30}px`;
        }
    };

    const pushGA4Event = (action: string, isFeedDisplay: boolean) => {
        if (typeof window == "undefined" || !window.dataLayer) return;
        const { category } = props;
        const actionPrefix = category && category.name ? (category.name === "דף הבית") ? "homepage" : category.name : "homepage";
        const gaAction = isFeedDisplay ? `video_${action}` : `${actionPrefix}_${action}`;

        window.dataLayer.push({
            event: "content_click",
            vertical_video_action: gaAction,
        });
    };

    if (!isOverlayOpen) return null;

    const isCurrentItemVideo = (() => {
        if (isSingleVideoDisplay) {
            const item = videoItems as SiteItemData;
            return item && item.media && (item.media as any).mediaType === MediaContentTypes.MEDIA_VIDEO;
        } else {
            const items = videoItems as SiteItemData[];
            const current = items && items[currentPlayingVideo];
            return current && current.media && (current.media as any).mediaType === MediaContentTypes.MEDIA_VIDEO;
        }
    })();

    const overlayClass = `vertical-video-overlay-player ${isSingleVideoDisplay ? "single-video-display" : "gallery-view"} ${!isCurrentItemVideo ? "non-video-item" : ""}`;

    return (
        <div className={overlayClass}>
            <div className="overlay-header">
                {overlayTitle && <div className="overlay-title">{overlayTitle}</div>}

                <div className="close-btn" onClick={onVideoOverlayClose}></div>

                {headerLogoClassName && <div className={`overlay-header-logo ${headerLogoClassName}`}></div>}
            </div>

            {isSingleVideoDisplay ?
                <Item
                    index={index}
                    domain={domain}
                    isMobile={isMobile}
                    languageCode={languageCode}
                    dynamicWidth={dynamicWidth}
                    dynamicHeight={dynamicHeight}
                    containerStyle={containerStyle}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    headerClassName={headerClassName}
                    isSubTitleVisible={isSubTitleVisible}
                    videoItem={videoItems as SiteItemData}
                    currentPlayingVideo={currentPlayingVideo}
                    key={(videoItems as SiteItemData).itemId}
                    onVideoOverlayClose={onVideoOverlayClose}
                />
                :
                <VerticalVideoGallery
                    isLTR={isLTR}
                    domain={domain}
                    isMobile={isMobile}
                    languageCode={languageCode}
                    pushGA4Event={pushGA4Event}
                    ItemComponent={ItemComponent}
                    showPrerollAds={showPrerollAds}
                    isTitleVisible={isTitleVisible}
                    headerClassName={headerClassName}
                    isSubTitleVisible={isSubTitleVisible}
                    selectedVideoIndex={selectedVideoIndex}
                    videoItems={videoItems as SiteItemData[]}
                    onVideoOverlayClose={onVideoOverlayClose}
                    currentPlayingVideo={currentPlayingVideo}
                    setCurrentPlayingVideo={setCurrentPlayingVideo}
                />
            }
        </div>
    )
}
